<div class="sz-lap">
  <div class="ures" *ngIf="!u"><ion-icon name="business-outline"></ion-icon>Válassz céget a fejlécben.</div>
  <ng-container *ngIf="u">
    <div class="n-szuro-sor">
      <button type="button" class="ov-gomb fo" *ngIf="ir" (click)="uj()"><ion-icon name="add"></ion-icon>Új tétel</button>
      <input type="search" [(ngModel)]="kereso" placeholder="Keresés…">
      <app-kamera-olvaso cim="Cikk keresése kamerával" (olvasott)="kereso = $event"></app-kamera-olvaso>
      <span class="spacer"></span><span class="halvany">{{ lathato.length }} tétel</span>
    </div>
    <div class="tabla-wrap">
      <table class="n-racs sz-racs">
        <thead><tr><th>Cikkszám</th><th>Megnevezés</th><th>Vonalkód</th><th>Fajta</th><th>Egység</th><th class="num">Nettó egységár</th><th>ÁFA</th></tr></thead>
        <tbody>
          <tr *ngFor="let p of lathato" class="kattinthato" [class.halvany-sor]="!+p.aktiv" (click)="nyit(p)">
            <td>{{ p.cikkszam }}</td><td><b>{{ p.nev }}</b><span class="halvany" *ngIf="+p.gyariszamos"> · gyári számos</span></td><td>{{ p.vonalkod }}</td><td>{{ p.fajta === 'PRODUCT' ? 'termék' : 'szolgáltatás' }}</td><td>{{ p.egyseg }}</td>
            <td class="num">{{ szam(p.egysegar) }} Ft</td><td>{{ kulcsNev(p.afa_kulcs) }}</td>
          </tr>
        </tbody>
      </table>
      <div class="sz-ures" *ngIf="!lathato.length">Még nincs termék vagy szolgáltatás.</div>
    </div>
  </ng-container>
</div>

<ion-modal [isOpen]="!!szerk" (didDismiss)="bezar()" cssClass="sorablak-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>{{ szerk?.id ? szerk.nev : 'Új termék / szolgáltatás' }}</ion-title></ion-toolbar></ion-header>
    <div class="sa-torzs">
      <div class="sa" *ngIf="szerk">
        <app-szerk-zar-sav [zar]="zar"></app-szerk-zar-sav>
        <div class="sa-doboz">
          <label class="kv-mezo" style="grid-column:1/-1"><span>Megnevezés</span><input type="text" [(ngModel)]="szerk.nev" [disabled]="!ir"></label>
          <label class="kv-mezo"><span>Cikkszám</span><input type="text" [(ngModel)]="szerk.cikkszam" [disabled]="!ir" maxlength="40"></label>
          <label class="kv-mezo"><span>Vonalkód</span><span class="kv-egyutt"><input type="text" [(ngModel)]="szerk.vonalkod" [disabled]="!ir" maxlength="40" placeholder="EAN / saját">
            <app-kamera-olvaso *ngIf="ir" (olvasott)="szerk.vonalkod = $event"></app-kamera-olvaso></span></label>
          <label class="kv-mezo"><span>Fajta</span><select [(ngModel)]="szerk.fajta" [disabled]="!ir"><option value="SERVICE">Szolgáltatás</option><option value="PRODUCT">Termék</option></select></label>
          <label class="kv-mezo"><span>Egység</span><input type="text" [(ngModel)]="szerk.egyseg" [disabled]="!ir" placeholder="db, óra, hó, kg…"></label>
          <label class="kv-mezo"><span>Nettó egységár</span><input type="number" step="0.01" [(ngModel)]="szerk.egysegar" [disabled]="!ir"></label>
          <label class="kv-mezo"><span>ÁFA</span><select [(ngModel)]="szerk.afa_kulcs" [disabled]="!ir"><option *ngFor="let k of sz.torzs.afa_kulcsok" [value]="k.kod">{{ k.nev }}</option></select></label>
          <label class="sa-jelolok"><input type="checkbox" [(ngModel)]="szerk.gyariszamos" [disabled]="!ir"> gyári számos (a szállítólevélen, számlán megadandó)</label>
          <label class="sa-jelolok"><input type="checkbox" [(ngModel)]="szerk.aktiv" [disabled]="!ir"> aktív</label>
          <label class="kv-mezo" style="grid-column:1/-1"><span>Megjegyzés</span><input type="text" [(ngModel)]="szerk.megjegyzes" [disabled]="!ir"></label>
        </div>
        <div class="sa-lab">
          <button type="button" class="ov-gomb fo" *ngIf="ir" [disabled]="zar && !zar.irhato" (click)="ment()"><ion-icon name="checkmark"></ion-icon>Mentés</button>
          <span class="spacer"></span><button type="button" class="ov-gomb" (click)="bezar()">Bezár</button>
        </div>
      </div>
    </div>
  </ng-template>
</ion-modal>
